import { AsyncThunkAction } from '@reduxjs/toolkit';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { PreferancesDatasProps } from '../types';

export const useTableExport = (
  totalCount: number | undefined,
  data: contentEntityDataType,
  getDataAction: (arg: any) => AsyncThunkAction<any, any, {}>,
  tablePreferences: PreferancesDatasProps | null,
  exportDataRef: React.MutableRefObject<any>
) => {
  const dispatch = useAppDispatch();

  const getExportedData = async (flags?: number) => {
    if (totalCount) {
      const res =
        tablePreferences &&
        (await dispatch(
          getDataAction({
            ...tablePreferences,
            pageNumber: 1,
            pageSize: totalCount,
          })
        ));

      if (res?.meta.requestStatus === 'fulfilled') {
        exportDataRef.current.link.click();
      }
    }
  };

  const mapExportedData = () => {
    const d = [];

    if (data?.totalCount && data?.totalCount > 0) {
      for (let i = 0; i < data?.totalCount; i++) {
        const row: { [key: string]: any } = {};

        data?.['columns']?.forEach((item: any) => {
          if (!item.isHidden) {
            row[item.header] = item.cells[i];
          }
        });

        d.push(row);
      }
    }

    return d;
  };

  return { getExportedData, mapExportedData };
};
